import React from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import debounce from "lodash/debounce";

import InputLabel from '@mui/material/InputLabel';
import TextField from '@mui/material/TextField';

import COLOR_THEMES from "../../../../../colorThemes";

import {setGroheFiltersSearchText} from "../../../../../actions/groheFunctions";
import {searchProductRequest} from "../../../../../api/search-api";
import {getCurrentLayout} from "../../../../appLayout";
import {updateNavigationCount} from "../../../../../actions/lookFunctions";
import {setNavigationLoading} from "../../../../../actions/navigationFunctions";

const GroheFiltersSearchInput = (props) => {
  const {activeTheme, groheFiltersSearchText, setGroheFiltersSearchText, lookActiveCategory, updateNavigationCount,
    setNavigationLoading} = props;

  const layout = getCurrentLayout();
  const featureGroup = layout.getFeatureGroupByPartId(lookActiveCategory);

  const debounceRequest = async (searchText) => {
    if (featureGroup && !featureGroup.getRealFeaturesReceivedProperty()) {
      return await searchProductRequest(featureGroup, searchText, (ended) => {
        setNavigationLoading(ended);
        if (!ended) {
          updateNavigationCount();
        }
      })
    }
  }

  const debounceFn = debounce(debounceRequest, 800);

  const handleSearchInputChange = async (event) => {
    setGroheFiltersSearchText(event.currentTarget.value);
    await debounceFn(event.target.value)
  }

  return (
    <div className="lk-search">
      <InputLabel shrink htmlFor="search-product" style={{ color: COLOR_THEMES[activeTheme].primary }}>
        <FormattedMessage id={"grohe.filter.searchProduct"}/>
      </InputLabel>
      <TextField id="search-product" label="" size="small" variant="outlined" fullWidth={true} type="search"
                 value={groheFiltersSearchText}
                 onChange={handleSearchInputChange} />
    </div>
  )
};

const mapStateToProps = (store) => {
  const {groheFiltersSearchText} = store.groheState;
  const {activeTheme} = store.serverState;
  const {lookActiveCategory} = store.lookState;

  return {
    groheFiltersSearchText,
    activeTheme,
    lookActiveCategory,
  };
};

const mapDispatchToProps = {
  setGroheFiltersSearchText,
  updateNavigationCount,
  setNavigationLoading,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(GroheFiltersSearchInput)
);
